import React from "react";

import classes from "./FeatureDealer.module.css";
import dealerImg from "../../../assets/Img/unKnownDealer.jpg";
import VisitProfile from "../../../assets/svg/VisitProfile.svg";
import Yellowstar from "../../../assets/svg/Yellowstar.svg";
import EmptyYellowstar from "../../../assets/svg/EmptyYellowstar.svg";

const FeatureDealer = (props) => (
    <div className={classes.FeatureDealerList}>
        {props.FeatruedDealers.map(dealer => {
            let dealerPic = dealer.profile_picture ?
                dealer.profile_picture :
                dealerImg;
            const companyOrPrivate = dealer.company_name !== null ?
                'Company ' :
                'Praivate';
            return (
                <div key={dealer.id} className={classes.FeatureDealerItem}>
                    <div className={classes.DealerInfo}>
                        <img src={dealerPic} alt='Dealer' width='50px' height='50px'/>
                        <div className={classes.DealerDetila}>
                            <h2>{dealer.name}</h2>
                            <p> {companyOrPrivate} </p>
                            <div>
                                <img src={Yellowstar} alt='' />
                                <img src={Yellowstar} alt='' />
                                <img src={Yellowstar} alt='' />
                                <img src={Yellowstar} alt='' />
                                <img src={Yellowstar} alt='' />
                                <img src={EmptyYellowstar} alt='' />
                            </div>
                        </div>
                    </div>
                    <div 
                    className={classes.ViewProfile}
                    onClick={()=>{props.routeHistory.push(`/Dealer?dealer=${dealer.id}`)}}
                    >
                        <img src={VisitProfile} alt="" />
                        <h2>Visit Profile</h2>
                    </div>
                </div>
            );
        })}
    </div>
);

export default FeatureDealer;